export const CONCIERGE_PATHNAME = '/concierge/';
export const CONCIERGE_LOADING_CREATIVE_ID = 'concierge-loading';
export const AUTH_ACTION = {
  CONCIERGE: {
    creativeId: 'concierge',
    signInTrackingId: 'concierge_begin_sign_up',
    signOutTrackingId: 'concierge_sign_out',
  },
};
